export default function smoothScrollToElement (el, offset = 0, duration = 600) {
  if (!el) return;

  const targetY = el.getBoundingClientRect().top + window.scrollY - offset;
  const startY = window.scrollY;
  const startTime = performance.now();

  function easeOutQuint(t) {
    return 1 - Math.pow(1 - t, 5);
  }

  function animate(time) {
    const elapsed = time - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const eased = easeOutQuint(progress);

    window.scrollTo(0, startY + (targetY - startY) * eased);

    if (progress < 1) requestAnimationFrame(animate);
  }

  requestAnimationFrame(animate);
}
